<!-- 学习周报-->
<template>
  <div :class="['learnweekList', { inApp: $root.$data.isApp || isMiniProgram }]">
    <common-title titleName="历史周报" :bcColor="'#FFF'" :zIndex="1000"> </common-title>
    <CommonLoading v-if="beforeLoading" />
    <div v-else>
      <div class="historyList" v-show="studyInfo.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="60"
          @load="onLoad"
        >
          <div v-for="(item, index) in studyInfo" :key="index">
            <h3>
              {{ item.statisticsStartTime.replace(/-/g, '.') }}-{{
                item.statisticsEndTime.replace(/-/g, '.')
              }}
            </h3>
            <div class="list" @click="onDetail(item)">
              <ul>
                <li>
                  <p>{{ item.questionCount }}<span>道</span></p>
                  <div>答题量</div>
                </li>
                <li>
                  <p>{{ item.correctRatio }}<span>%</span></p>
                  <div>正确率</div>
                </li>
                <li>
                  <p>{{ item.rank }}<span>名</span></p>
                  <div>本周排名</div>
                </li>
              </ul>
            </div>
          </div>
        </van-list>
      </div>
      <div class="nodata" v-show="studyInfo.length == 0">
        <div>
          <img src="@/assets/img/weekReport/nodata.png" alt="" />
          <p>您还没做题呢，暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { replaceHyphens, whatEev } from '@/utils/tools';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import { reqAnswerPage } from '@/api/personal/personalReport';

export default {
  components: {
    EmptyData,
    CommonLoading,
  },
  data() {
    return {
      beforeLoading: true,
      isMiniProgram: false,
      finished: false,
      loading: false,
      pageParms: {
        pageNum: 1,
        pageSize: 20,
      },
      total: 0,
      studyInfo: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      const res = await reqAnswerPage(this.pageParms);
      if (res.code === 0 && res.data.data?.length) {
        this.beforeLoading = false;
        const { data, total } = res.data;
        this.total = total;
        this.studyInfo = [...this.studyInfo, ...data];
        this.loading = false;
        this.pageParms.pageNum += 1;
        if (total === this.studyInfo.length) {
          this.finished = true;
        }
      } else {
        this.beforeLoading = false;
      }
    },
    endTime(value) {
      let val = value.slice(5);
      return val.replace(/-/g, '.');
    },
    //详情页
    onDetail(item) {
      this.$router.push({
        path: '/weekReport/detail',
        query: {
          weekId: item.id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.learnweekList {
  position: relative;
  padding: 100px 36px 200px 36px;
  .historyList {
    h3 {
      display: inline-block;
      font-size: 22px;
      font-weight: 500;
      color: #333333;
      height: 43px;
      line-height: 43px;
      background: #f0f0f0;
      border-radius: 80px 181px 181px 80px;
      padding: 0 20px;
      margin: 24px 0;
    }
    .list {
      height: 159px;
      background: #ffffff;
      border-radius: 14px;
      margin: 0 auto;
      padding: 36px 60px;
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
          position: relative;
          div {
            font-size: 25px;
            font-weight: 400;
            color: #999999;
            text-align: center;
          }
          p {
            font-size: 36px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 20px;
            text-align: center;
            span {
              font-size: 22px;
              color: #333333;
              margin-left: 6px;
            }
          }
        }
        li:after {
          position: absolute;
          right: -70px;
          top: 18px;
          display: block;
          content: '';
          width: 2px;
          height: 47px;
          background: #f6f6f6;
        }
        li:last-child:after {
          display: none;
        }
      }
    }
  }
  .nodata {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    img {
      display: block;
      width: 308px;
      height: 197px;
      margin: 0 auto;
    }
    p {
      font-size: 25px;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }
  }
}
.inApp {
  padding-top: 0px;
}
</style>
